<template>
  <button
    :type="type"
    class="home-button"
    :class="['home-button--' + variant, $attrs.class]"
    v-bind="$attrs"
    v-on="$listeners"
  >
    <slot />
  </button>
</template>

<script>
export default {
  name: "Button",
  inheritAttrs: false,

  props: {
    variant: {
      type: String,
      default: "base",
    },
    type: { type: String, default: "button" },
  },
};
</script>

<style scoped lang="less">
.home-button {
  height: 52px;
  border-radius: 10px;
  cursor: pointer;
  border: none;
  font-family: "Montserrat", sans-serif;
  font-weight: 600;
  font-size: 16px;
  line-height: 1;
  text-align: center;

  &--base {
    background-color: #fede09;
    color: #000;
  }

  &--outline {
    background-color: transparent;
    color: #ffffff;
    border: 2px solid #ffffff;
  }

  &--gradient {
    background: linear-gradient(90deg, #0ad8db 0%, #8e7acf 100%);
    color: #ffffff;
  }
  &--plain {
    background-color: transparent;
    border: none;
    color: inherit;
    padding: 0;
    height: auto;
    color: #ffffff;
  }
}
</style>
